/**
 * Prepara los datos para hacer una capa con un solo campo de categorias, esto es necesario para usar la simnbologia dinamica 
 * que ya trae dai-maps
 * @param {*} centroides 
 */
export const reducerMaquinariaCentroides = function (centroides,sort=true){
    const columns = ["maq_trilla","maq_motog","otra_maq"];
    const labels = ["Trilladoras","Motogrúas","Otras"];
    
    const datos = centroides.features.reduce((acum,current)=>{
        const feature = Object.assign({},current)
        columns.forEach((column,idx)=>{
            const value = feature.properties[column]
            let other_feature = JSON.parse(JSON.stringify(feature)) //Object.assign({},feature)
            
            other_feature.properties["maquinaria"] = labels[idx]
            other_feature.properties["maquinaria_v"] = value
            delete other_feature.properties[column]
            if(value>0){
                //console.log(column,"here",idx,labels[idx],value)
                
                acum.push(other_feature)
            }
        })
        //console.log(feature.properties.maq_trilla,feature.properties.maq_motog,feature.properties.otra_maq)
        return acum
    },[])
    if(sort){
        return datos.sort((a,b)=>{
            if ( a.properties.maquinaria_v < b.properties.maquinaria_v ){
                return 1;
            }
            if ( a.properties.maquinaria_v > b.properties.maquinaria_v ){
                return -1;
            }
            return 0;
        })
    }

    return datos
    
    
}

